var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.117676 31.9828C0.117676 33.0142 0.527397 34.0034 1.2567 34.7327C1.98601 35.462 2.97517 35.8717 4.00656 35.8717H31.2288C32.2602 35.8717 33.2493 35.462 33.9786 34.7327C34.708 34.0034 35.1177 33.0142 35.1177 31.9828V4.76059C35.1177 3.7292 34.708 2.74004 33.9786 2.01073C33.2493 1.28142 32.2602 0.871704 31.2288 0.871704H4.00656C2.97517 0.871704 1.98601 1.28142 1.2567 2.01073C0.527397 2.74004 0.117676 3.7292 0.117676 4.76059V31.9828ZM17.6177 6.70504H29.2843V18.3717H25.3955V10.5939H17.6177V6.70504ZM5.95101 18.3717H9.8399V26.1495H17.6177V30.0384H5.95101V18.3717Z",
    fill: "#0a1d47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.cbd6e9e28b6da01b3245af40c14432be.svg";
export { ForwardRef as ReactComponent };